import { render, staticRenderFns } from "./ProjectContact.vue?vue&type=template&id=3ee3e59d&scoped=true&"
import script from "./ProjectContact.vue?vue&type=script&lang=js&"
export * from "./ProjectContact.vue?vue&type=script&lang=js&"
import style0 from "./ProjectContact.vue?vue&type=style&index=0&id=3ee3e59d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ee3e59d",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VRow,VSelect,VSimpleTable})
